import { baseApi, client } from '../baseApi.ts';
import GetModelsResponse from '../response/GetModelsResponse.ts';
import GetStyleCategoriesResponse from '../response/GetStyleCategoriesResponse.ts';
import GetControlNetModelsResponse from '../response/GetControlNetModelsResponse.ts';
import GetVideoModelsResponse from '../response/GetVideoModelsResponse.ts';

export const modelEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getModels: builder.query({
			// @ts-ignore
			queryFn: async ({
				page = 1,
				pageSize = 100,
				type,
			}: { page?: number; pageSize?: number; type?: string } = {}) => {
				try {
					const request = { page, page_size: pageSize, ...(type && { type }) };
					const response = await client.models.list(request);
					const data = new GetModelsResponse(response?.data).formatModelsData();
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['Models'],
		}),
		getModelCategories: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.models.categories();
					const data = new GetStyleCategoriesResponse(response?.data).formatCategoriesData();
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['ModelCategories'],
		}),
		getListControlNetModels: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.models.listControlNetModels();
					const data = new GetControlNetModelsResponse(response?.data).formatControlNetModelsData();
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['ControlNetModels'],
		}),
		getListVideoAnyoneModels: builder.query({
			// @ts-ignore
			queryFn: async ({ type }) => {
				try {
					const request = { generation_type: type };
					const response = await client.models.listVideoAnyoneModels(request);

					const data = new GetVideoModelsResponse(response?.data).formatVideoModelsData();
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['VideoAnyoneModels'],
		}),
	}),
});
